import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import keyOn from '../Leads/key_on'
import { Link } from 'react-router'
import timeAgo from 'time_ago_in_words'
import Form from '../settings/Form'

const MessageTypes = {
  'form:cma': 'Market Value Request',
  'form:contact': 'Contact Form',
  'listing:tour': 'Request A Tour',
  'listing:info': 'Ask A Question',
}

@keyOn('params.message_id')
@inject('messages', 'websites')
@observer
export default class WebsiteMessageDetails extends Component {

  get message() {
    return this._message || (this._message = this.props.messages.findById(this.props.params.message_id))
  }

  get website() {
    return this.props.websites.current
  }

  componentDidMount() {
    this.getMessage()
  }

  getMessage() {
    this.props.messages.load(this.props.params.message_id)
  }

  renderContent() {
    const { listing_details } = this.message
    return (
      <div className={`panel padded ${listing_details ? 'half' : 'full'}`}>
        <h3>Message</h3>
        <p>{this.message.content}</p>
      </div>
    )
  }

  renderListing() {
    const { listing_details } = this.message
    if (listing_details) {
      return (
        <div className="panel padded half">
          <h3>Listing Details</h3>

          <div style={{ textAlign: 'center' }}>
            <div>
              <Link to={`/website/${this.website.id}/leads/${this.message.lead.id}`}>
                <img style={{maxWidth: '100%'}} src={listing_details.images[0]} />
              </Link>
            </div>
            <h2>
              <Link to={`/website/${this.website.id}/leads/${this.message.lead.id}`}>
                {listing_details.address} {listing_details.citystate}
              </Link>
            </h2>
          </div>
        </div>
      )
    }
  }

  renderFields() {
    const { fields } = this.message
    return (
      <div className="panel padded full">
        <h3>Additional Details</h3>
        <div className="message-fields">
          {Object.keys(fields).map(field => (
            <div key={field} className="message-field">
              <span>{field.replace(/_/g, ' ')}</span> <strong>{fields[field]}</strong>
            </div>
          ))}
        </div>
      </div>
    )
  }

  renderHeading() {
    return (
      <div className="panel padded full">
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ fontSize: '2em' }}><span>New</span> <strong>Message</strong> <div className="message-type-badge">{MessageTypes[this.message.fields.source] || this.message.type}</div></div>
            <div>
              {/* <a style={{ color: 'red', marginLeft: '20px' }} href="#" onClick={this.handleDelete}>Delete</a> */}
              <a className="button" href={`mailto:${this.message.lead.email}`}>Reply via Email</a>
            </div>
          </div>
          <div>From <Link to={`/website/${this.website.id}/leads/${this.message.lead.id}`}>{this.message.lead.name}</Link> {timeAgo(new Date(this.message.created_at))}</div>
        </div>
      </div>
    )
  }

  render() {
    if (!this.message) {
      return <div className="loading">Loading...</div>
    }

    return (
        <Form onData={x => x}>
      <div className="container padded message">

          <span />
          
          {this.renderHeading()}

          {this.renderContent()}

          {this.renderListing()}
          
          {this.renderFields()}

          {/* <button type="submit" className="big shadowed">Reply via Email</button> */}
      </div>
        </Form>
    )
  }

}


// WEBPACK FOOTER //
// client/components/sections/website/Messages/Details.js